var Scroll = /** @class */ (function () {
    function Scroll(easing) {
        this.easing = easing;
    }
    Scroll.prototype.scrollTo = function (destination, duration, callback) {
        if (duration === void 0) { duration = 300; }
        if (callback === void 0) { callback = function () { }; }
        var parar = false;
        var easing = this.easing;
        var start = window.scrollY;
        var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
        var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        var destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
        var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
        window.addEventListener('mousewheel', function () { return parar = true; });
        function scroll() {
            var now = 'now' in window.performance ? performance.now() : new Date().getTime();
            var time = Math.min(1, ((now - startTime) / duration));
            var timeFunction = easing(time);
            window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));
            if (Math.abs(window.scrollY - destinationOffsetToScroll) < 1) {
                if (callback) {
                    callback();
                }
                return;
            }
            if (!parar) {
                requestAnimationFrame(scroll);
            }
        }
        scroll();
    };
    return Scroll;
}());
export default Scroll;
